import produce from 'immer';
import {
  ActionType,
  createAsyncAction
} from 'typesafe-actions';

export const GET_SERIES_REQUESTED = 'GET_SERIES_REQUESTED';
export const GET_SERIES_SUCCEEDED = 'GET_SERIES_SUCCEEDED';
export const GET_SERIES_FAILED = 'GET_SERIES_FAILED';

export const getSerieAsync = createAsyncAction(
  GET_SERIES_REQUESTED,
  GET_SERIES_SUCCEEDED,
  GET_SERIES_FAILED,
)<string, any[], Error>();


export type SerieActionTypes =
  | ActionType<typeof getSerieAsync>

type ErrorMessages = { getSerieFailed?: string };

type SerieState = {
  readonly isGettingSerie: boolean;
  readonly errorMessages: ErrorMessages;
  readonly series: Array<any>;
};

export const defaultSerieState: SerieState = {
  isGettingSerie: false,
  errorMessages: {},
  series: [],
};

export default function accountReducer( state = defaultSerieState, action: SerieActionTypes ) {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_SERIES_REQUESTED:
        draft.series = [];
        draft.isGettingSerie = true;
        delete draft.errorMessages.getSerieFailed;
        return;
      case GET_SERIES_SUCCEEDED:
        draft.isGettingSerie = false;
        draft.series = action.payload;
        return;
      case GET_SERIES_FAILED:
        draft.isGettingSerie = false;
        draft.errorMessages.getSerieFailed = action.payload.message;
        return;
    }
  });
};